module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/whiteboard-icon-eda9c36ae3f2cc0853c9769aa29c3ff4.png";